import React from "react";

const UploadTriggerCard = ({
  icon,
  text,
  buttonText,
  onClick,
  required = false, // 🔥 new prop
}) => {
  return (
    <div
      onClick={onClick}
      className="border-2 border-dashed rounded-xl p-4 flex flex-col md:flex-row items-center justify-between cursor-pointer hover:bg-gray-50 transition"
    >
      <div className="flex items-center gap-3">
        <img src={icon} alt="upload" className="w-6 h-6" />
        <p className="text-sm text-gray-700 flex items-center">
          {text}
          {required && <span className="text-red-500 ml-1">*</span>}
        </p>
      </div>

      <button type="button" className="text-sm font-medium text-[#FF6943]">
        {buttonText}
      </button>
    </div>
  );
};

export default UploadTriggerCard;
